import React, { Component } from 'react';
import { connect } from 'react-redux';
import SmEdit from 'containers/CompanyManagement/CompanyInfo/Edit';
import { EditProps } from 'containers/CompanyManagement/CompanyInfo/components/Edit/supplierEditHOC';
import * as actions from 'modules/actions/outSupplierManagement';
import { getAttachementUploadUrl } from 'containers/OutCompanyManagement/utils';

class Edit extends Component<EditProps> {
  render() {
    return (
      <SmEdit
        cancelUrl="/outCompanyManagement/outCompanyInfo"
        getAttachementUploadUrl={getAttachementUploadUrl}
        {...this.props}
      />
    );
  }
}

const mapStateProps = (state: any, ownProps: any) => {
  const data = state.outSupplierManagement.detail;
  const filters = state.outSupplierManagement.supplierOptions;
  return {
    data,
    filters,
  };
};

const mapDispatchToProps = () => {
  return {
    getDetail: actions.getDetail,
    onSave: actions.saveDetail,
    onChange: actions.chagneDetail,
  };
};

export default connect(mapStateProps, mapDispatchToProps)(Edit);
